"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, Skeleton } from "@mui/material";
import React from "react";
import { MOBILE_APPBAR_HEIGHT } from "#/features/appBar/constants";
import { usePlaygroundMobileLayout } from "#/features/playground/hooks/usePlaygroundMobileLayout";
import { SplitPanelsLayoutSkeleton } from "#/shared/ui/templates/SplitPanelsLayout/SplitPanelsLayoutSkeleton";
const MobilePlaygroundPanelsSkeleton: React.FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      height: `calc(100vh - ${MOBILE_APPBAR_HEIGHT}px - env(safe-area-inset-top, 0px))`,
      px: 1,
      pb: 1,
      overflow: "hidden"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box component="main" sx={t0}><Skeleton variant="rounded" animation="wave" sx={{
        height: "100%",
        borderRadius: 2,
        cursor: "wait"
      }} /></Box>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};

/** Playground panel-area skeleton (desktop split layout or mobile full-bleed). */
export const PlaygroundPanelsSkeleton: React.FC = () => {
  const $ = _c(2);
  const isMobile = usePlaygroundMobileLayout();
  if (isMobile) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <MobilePlaygroundPanelsSkeleton />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SplitPanelsLayoutSkeleton />;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};